import { render, staticRenderFns } from "./BillingReport.vue?vue&type=template&id=5c97ae6a&scoped=true"
import script from "./BillingReport.vue?vue&type=script&lang=js"
export * from "./BillingReport.vue?vue&type=script&lang=js"
import style0 from "./BillingReport.vue?vue&type=style&index=0&id=5c97ae6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97ae6a",
  null
  
)

export default component.exports